<!-- src/pages/WelcomePage.vue -->
<template>
  <div class="text-center">
    <div
      class="w-16 h-16 bg-bc-indigo-100 rounded-full flex items-center justify-center mx-auto mb-6"
    >
      <font-awesome-icon :icon="['fas', 'check-circle']" class="text-2xl text-bc-indigo-600" />
    </div>

    <h2 class="text-2xl font-bold text-gray-900 mb-2">Welcome to Smart Teacher!</h2>
    <p class="text-gray-600 mb-6">
      Your account is all set. The best way to get started is to add your first class &mdash; it
      only takes a minute.
    </p>

    <div v-if="isAuthenticated" class="space-y-3">
      <RouterLink
        to="/home"
        class="block w-full bg-bc-indigo-600 text-white font-semibold py-3 px-6 rounded-lg hover:bg-bc-indigo-700 transition-colors text-center"
      >
        Go to Dashboard
      </RouterLink>
    </div>

    <div v-else class="space-y-3">
      <RouterLink
        to="/login"
        class="block w-full bg-bc-indigo-600 text-white font-semibold py-3 px-6 rounded-lg hover:bg-bc-indigo-700 transition-colors text-center"
      >
        Log In
      </RouterLink>
      <RouterLink
        to="/get-started"
        class="block w-full bg-white text-bc-indigo-600 font-semibold py-3 px-6 rounded-lg border border-bc-indigo-200 hover:bg-bc-indigo-50 transition-colors text-center"
      >
        Create Account
      </RouterLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { useAuthStore } from '@/store/AuthStore'
import { computed } from 'vue'

const auth = useAuthStore()
const isAuthenticated = computed(() => auth.isAuthenticated)
</script>
